module.exports = __webpack_public_path__ + "fonts/iconfont.dfc3d103.ttf";